"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appMenu = exports.appMenus = void 0;

var appMenus = function appMenus(applist) {
  return applist.map(function (app) {
    var menu = {
      app: app.id,
      icon: app.props.icon,
      title: app.props.title,
      // path: app.props.path,
      menus: app.menus
    };

    if (menu.menus && typeof menu.menus === "function") {
      menu.mode = "popup";
      menu.menus = menu.menus(app.props.path);
    }

    return menu;
  }).map(function (appMenu) {
    if (appMenu.menus) appMenu.menus = addAppId(appMenu.menus, appMenu.app);
    return appMenu;
  });
};

exports.appMenus = appMenus;

var appMenu = function appMenu(apps) {
  return appMenus(apps)[0].menus;
};

exports.appMenu = appMenu;

function addAppId(menus, appId) {
  return menus.map(function (menu) {
    menu.app = appId;
    if (menu.menus) menu.menus = addAppId(menu.menus, appId);
    return menu;
  });
}